/**
 * NUDIENT: Väljaren för att välja telefonmodell, paket B2d, M-070 och specen
 * 4.6, 4.7 och 4.11. Webbkomponenten nudient-model-picker, markup i
 * snippets/nudient-model-picker.liquid. Plan: nudient/PLAN-B2-sidhuvud.md
 * punkt 23.
 *
 * - Fältet fäller ut menyn där det står. Bara en meny är utfälld åt gången.
 * - Listan byggs vid första utfällningen ur #nudient-model-data, genom
 *   @nudient/model-store. Ingen nätverksförfrågan, specen 4.11.
 * - Modellerna i datans ordning, grupperade per märke i den ordning grupperna
 *   först förekommer, och "Andra modeller" sist, M-009 och M-070.
 * - Sökningen görs på gemener utan mellanslag och bindestreck, mot namnet.
 *   Antalet träffar annonseras för skärmläsare.
 * - Varje rad är en riktig länk till modellens kollektion, eller till
 *   phone-cases om den saknas, M-023. Vanligt klick anropar setModel() först.
 *   På en modells egen kollektion går kunden till den nya modellens kollektion
 *   med filter och sortering kvar. Saknar den valda modellen egen kollektion
 *   fälls menyn in och kunden stannar, som på andra sidor. På alla andra sidor
 *   fälls menyn in och
 *   valet sparas, också på phone-cases och produktsidan tills
 *   kollektionsvågen och D1, M-070. Cmd, Ctrl, Skift, Alt och alla andra
 *   knappar än vänster musknapp fångas inte.
 * - Fokus när menyn fälls ut, tillägget till M-084 8 oktober 2026 och specen
 *   4.11: på en enhet som kan hovra, (hover: hover) som rutan med färgnamnet
 *   i del c, får sökfältet fokus. På pekskärm får den valda modellens rad
 *   fokus, eller listans första rad, så att tangentbordet inte fälls ut och
 *   skärmläsare och tangentbord hamnar inne i väljaren. Listan scrollas så
 *   att raden syns, utan att sidan flyttas. Trycker kunden i sökfältet kommer
 *   tangentbordet som vanligt.
 * - Musklick på raderna och fältet i den öppna listan flyttar inte fokus,
 *   så att Horizons meny inte stänger panelen i Safari, M-149 och
 *   nudient/FEL-menyvaljaren.md.
 * - Fokus: sökfältet när menyn fälls ut. Pil upp och pil ned mellan sökfältet
 *   och raderna. Esc fäller in bara menyn, med fokus på fältet, och stoppar
 *   Esc från att nå megamenyn. Tab ut till en annan del av sidan och tryck
 *   utanför fäller in. Går fokus till ingenting, till exempel vid ett tryck på
 *   en yta som inte kan få fokus, står menyn kvar tills trycket utanför.
 * - Sökfältet får fokus bara när datan finns. Saknas datan döljs sökfältet och
 *   listan, och ritningens fel visas, Error 597:12488.
 * - Vid sökningen döljs rader och märken utan träff, och vid noll träffar visas
 *   "Inga modeller matchar". Listan börjar då överst.
 * - Vald modell märks med aria-current, som ger den grå raden i
 *   assets/nudient-model-picker.css. Utan val får fältet data-empty, som ger
 *   texten "Välj modell" i color/text/secondary.
 * - Etiketten och NoMatch följer model:change.
 * - Listan räknas som byggd bara när raderna finns i sidan. Har något
 *   raderat dem, till exempel Horizons omhämtning av sidhuvudet, byggs den
 *   igen vid nästa utfällning, M-085.
 * - Läget för filtret, paket E3, M-013 ändringen och M-100: på en kollektion
 *   där snippets/nudient-model-filter-head.liquid har satt
 *   window.nudientFilter filtrerar väljaren på plats, utom i läget pdp. Det
 *   gäller alla väljare på sidan, också megamenyns rad.
 *   - Fältet visar modellen i adressen, som sidan är filtrerad på, också när
 *     den är standardmodellen och inte sparad, M-007.
 *   - Raderna är länkar till samma sida med modellens värde i filtret, så
 *     att de går att öppna i en ny flik. Värdet är filtrets eget,
 *     window.nudientFilter.values, M-100 punkt 6.
 *   - Ett vanligt klick sparar valet, byter modellen i adressen, behåller
 *     övriga filter och sorteringen, tar bort page och låter Horizons
 *     updateFiltersByURL rita om rutnätet. Ingen omladdning.
 *   - Efter bytet säger skriptet till de andra väljarna med
 *     nudient-model-picker:filter, så att alla visar samma modell.
 *   - Söksidan, paket F2 och M-105 punkt 2: window.nudientFilter har
 *     noDefault och group. Utan modell i adressen visar fältet kundens
 *     sparade modell, den som gruppen "For your [modell]" använder, och
 *     "Välj modell" utan sparat val. Ett byte sparar modellen, och
 *     assets/nudient-search-model.js byter gruppen. Listan filtreras inte.
 *     Ändring av M-105 punkt 2, M-142. Med modellen i adressen filtrerar
 *     väljaren som förut.
 *   - På en modells egen sida, där ingen window.nudientFilter finns, leder
 *     valet till den nya modellens sida som förut, utan modellens filter i
 *     adressen.
 * - Fältets, sökfältets och listans lyssnare kopplas bara första gången
 *   väljaren sätts in på sidan. Väljaren i filterlådan flyttas in av
 *   assets/nudient-filter.js, och med två lyssnare öppnades och stängdes
 *   menyn i samma klick, granskningen av E3 14 oktober 2026.
 * - Läget pdp, produktsidan, D1 del g och M-086: raderna leder till
 *   systerprodukterna, och annars till modellens kollektion, M-014. Systern
 *   slås upp för en modell i taget:
 *   - Kandidaterna är produktens undantag ur raden, och sedan produktens
 *     adress med modellen utbytt, utan och med -2, tillägget till M-014.
 *   - Varje kandidat frågas med sections/nudient-model-targets.liquid, och
 *     de fyra fälten jämförs med sidans produkt. Adressen kommer ur svaret.
 *   - Finns ingen syster i samma färg prövas reserven ur raden, samma
 *     skaltyp och MagSafe i den färg som står först i färgradens ordning,
 *     steg b i tillägget till M-084. Där jämförs modell, skaltyp och
 *     MagSafe. Annars leder raden till modellens kollektion.
 *   - Uppslagningen börjar efter 100 ms hovring eller fokus på raden, och
 *     direkt vid tryck på pekskärm. Högst en åt gången, och en ny avbryter
 *     den förra. Svaren sparas per modell för sidvisningen.
 *   - Raden har kvar kollektionens adress, och data-nudient-pending, tills
 *     svaret har kommit. Då ber skriptet assets/nudient-product.js förhämta
 *     sidan, med händelsen nudient:prefetch.
 *   - Klick innan svaret har kommit: raden får aria-busy, och klicket väntar
 *     högst 1,5 sekunder. Sedan går kunden till systern, eller till
 *     kollektionen. Länken klickas då igen, som ett vanligt klick.
 *   - Vid modellbyte hamnar kunden högst upp på den nya sidan, tillägget
 *     till M-084. Scrollningen behålls bara vid färg- och storleksbyte.
 *   - När adressen är klar stängs menyn direkt vid klicket, och fältet får
 *     aria-busy, som visar väntemarkören tills sidan byts. Väntar raden på
 *     uppslagningen stängs menyn när adressen är klar. Tillbaka med
 *     bakåtknappen tas väntlägena bort, tillägget till M-084 8 oktober 2026.
 *   - Öppna i ny flik ger kollektionen, för skal phone-cases med modellen,
 *     M-157, om raden inte hovrats, och alltid på
 *     pekskärm, accepterat i M-086.
 *   Klicket sparar valet med källan pdp. Den egna modellen fäller bara in
 *   menyn.
 * - AirPods-fodral, M-174: raden har läget airpods och en färdig lista,
 *   data-nudient-airpods ur snippets/nudient-airpods-models.liquid, med
 *   AirPods-modellerna i dagens sajts ordning och en adress per modell.
 *   Listan ersätter modellerna ur modellminnet, ingen uppslagning görs, och
 *   ett byte sparar inget i modellminnet, så sidhuvudets väljare påverkas
 *   inte. Fältet visar produktens egen AirPods-modell.
 * - Alla skal med telefonmodell har data-cases-url, rättat 3 november 2026,
 *   snippets/nudient-model-row.liquid, så att ett byte aldrig går till
 *   modellens kollektion, inte heller till en annan tillverkare.
 * - Skal utan syster, M-157 och nudient/PLAN-modellbyte-saknas.md: finns
 *   varken exakt syster eller samma skaltyp och MagSafe i reservlistan leder
 *   raden till phone-cases filtrerad på modellen, data-cases-url, samma
 *   adress som menylänken. Det är också radens adress innan svaret har
 *   kommit, och när klicket har väntat 1,5 sekunder utan svar. Bara när
 *   svaret är att systern saknas sparas skälet i sessionStorage,
 *   nudient:model-miss, precis före sidbytet: skaltypens namn, modellens
 *   namn, filtrets värde och tiden. assets/nudient-model-miss.js visar raden
 *   på phone-cases en gång. Adressen får ingen ny parameter.
 * - Skärmskydd, M-133: raden har läget protector, data-own-kind, ur
 *   snippets/nudient-model-row.liquid. Systern är skyddet för den valda
 *   modellen av samma sort, fältet attribute.colour, till exempel Premium.
 *   Skriptet frågar kollektionen screen-protectors filtrerad på modellen med
 *   sections/nudient-protector-targets.liquid och väljer det skydd som har
 *   modellen i attribute.compatible_models och samma sort. Finns inget leder
 *   raden till kollektionen filtrerad på modellen, aldrig till skalen. Den
 *   adressen är också radens adress innan svaret har kommit.
 * - Linsskydd, M-133 tillägget: raden har läget lens. Skriptet hämtar alla
 *   linsskydd en gång när sidan laddas, med sökningen och
 *   sections/nudient-protector-targets.liquid. Listan visar bara modellerna
 *   som har ett linsskydd i attribute.compatible_models, och raden leder
 *   direkt till linsskyddet, i samma sort om den finns, annars det första.
 *   Innan svaret har kommit visar listan bara produktens egen modell.
 *
 * Värden som inte är tokens:
 * - [number]: platshållaren i de översatta texterna, ersätts med antalet.
 * - other: märket för modeller vars märke inte gick att härleda, ur A0.
 * - collection: mallens namn för en kollektion, M-019.
 * - pdp: läget för produktsidan och källan i model:change, specen 4.10.
 * - nudient-model-targets: sektionens filnamn, section_id i förfrågan.
 * - nudient-model-sibling: id på svaret i sektionen.
 * - nudient-protector-targets: skärmskyddens sektion och id på svaret, M-133.
 * - protector: radens läge för skärmskydd, M-133.
 * - lens: radens läge för linsskydd, M-133 tillägget.
 * - nudient:model-miss: nyckeln i sessionStorage för raden på phone-cases,
 *   M-157.
 * - filter.p.m.attribute.compatible_models: Shopifys filter på fältet
 *   compatible_models, samma som kollektionernas modellfilter, M-133.
 * - 100: millisekunder hovring eller fokus innan uppslagningen börjar, M-086.
 * - 1500: millisekunder som ett klick väntar på svaret, M-086.
 * - -1 och -2: ändelserna i M-014, och -2 som andra gissning.
 * - nudient:prefetch: händelsen som ber assets/nudient-product.js förhämta.
 * - nudient-model-picker:open: händelsen som fäller in andra menyer.
 * - nudient-model-picker:filter: händelsen efter ett modellbyte i filtret.
 * - page: sidnumrets parameter, som Horizon också tar bort vid filterbyte,
 *   assets/facets.js rad 61.
 * - facets-form-component och updateFiltersByURL: Horizons filterformulär
 *   och dess metod, assets/facets.js rad 164 till 172.
 * - (hover: hover): webbläsarens fråga om enheten kan hovra, som i
 *   assets/nudient-product.js för rutan med färgnamnet i del c.
 * - 2: raden mitt i listan, halva listans höjd.
 * - 0 i scrollTop: listan börjar överst efter varje sökning.
 */

import { getModel, getModelName, getModels, getStoredModel, findModel, hasData, setModel } from '@nudient/model-store';

const OPEN_EVENT = 'nudient-model-picker:open';
const canHover = window.matchMedia('(hover: hover)');

/* Systern för vald modell, M-086 */
const SECTION = 'nudient-model-targets';
/* Skärmskyddet för vald modell, M-133 */
const PROTECTOR_SECTION = 'nudient-protector-targets';
const MODELS_PARAM = 'filter.p.m.attribute.compatible_models';
/* Skälet till bytet till phone-cases, M-157, läses av assets/nudient-model-miss.js */
const MISS_KEY = 'nudient:model-miss';
const HOVER_DELAY = 100;
const CLICK_TIMEOUT = 1500;

/** Svaren per modell för sidvisningen: adressen till systern, eller null. */
const siblings = new Map();
/** @type {{ handle: string, controller: AbortController, promise: Promise<string | null> } | null} */
let lookup = null;

/** @param {unknown} value */
const clean = (value) => String(value ?? '').trim().toLowerCase();
/** @param {string} text */
const handleize = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
/** @param {string} text */
const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** @param {Element} row */
function ownProduct(row) {
  const data = row instanceof HTMLElement ? row.dataset : {};
  const read = (selector) => {
    try {
      return JSON.parse(row.querySelector(selector)?.textContent || '{}') || {};
    } catch {
      return {};
    }
  };
  const exceptions = read('[data-nudient-sibling-exceptions]');
  const fallbacks = read('[data-nudient-sibling-fallbacks]');
  return {
    handle: data.ownHandle || '',
    model: data.ownModel || '',
    type: clean(data.ownType),
    colour: clean(data.ownColour),
    magsafe: clean(data.ownMagsafe),
    kind: data.ownKind || '',
    protectorUrl: data.protectorUrl || '',
    casesUrl: data.casesUrl || '',
    typeLabel: data.ownTypeLabel || '',
    exceptions,
    fallbacks,
  };
}

/**
 * phone-cases filtrerad på modellen, som menylänken, M-157.
 * @param {ReturnType<typeof ownProduct>} own
 * @param {{ handle: string, model?: string, name?: string }} model
 */
function casesHref(own, model) {
  const url = new URL(own.casesUrl, window.location.origin);
  url.searchParams.set(MODELS_PARAM, model.model || model.name || '');
  return url.pathname + url.search;
}

/**
 * Sparar skälet till bytet precis före sidbytet, M-157. Utan sessionStorage
 * kommer kunden till phone-cases utan raden.
 * @param {ReturnType<typeof ownProduct>} own
 * @param {{ handle: string, model?: string, name?: string }} model
 */
function rememberMiss(own, model) {
  try {
    sessionStorage.setItem(
      MISS_KEY,
      JSON.stringify({ type: own.typeLabel, model: model.name || '', value: model.model || model.name || '', at: Date.now() })
    );
  } catch {}
}

/**
 * Skärmskyddens kollektion filtrerad på modellen, M-133.
 * @param {ReturnType<typeof ownProduct>} own
 * @param {{ handle: string, model?: string }} model
 */
function protectorHref(own, model) {
  const url = new URL(own.protectorUrl, window.location.origin);
  url.searchParams.set(MODELS_PARAM, model.model || '');
  return url.pathname + url.search;
}

/** Linsskydden per adress till sökningen, hämtade en gång, M-133 tillägget. */
const lensLists = new Map();

/**
 * Alla linsskydd, ur sökningen efter produkttypen.
 * @param {string} url
 * @returns {Promise<Array<{ url: string, sort: string | null, models: string[] }>>}
 */
function lensProducts(url) {
  if (!lensLists.has(url)) {
    const separator = url.includes('?') ? '&' : '?';
    lensLists.set(
      url,
      fetch(`${url}${separator}section_id=${PROTECTOR_SECTION}`)
        .then((response) => (response.ok ? response.text() : ''))
        .then((html) => {
          const script = new DOMParser().parseFromString(html, 'text/html').getElementById(PROTECTOR_SECTION);
          const list = JSON.parse(script?.textContent || '[]');
          return Array.isArray(list) ? list.filter((item) => item?.url && Array.isArray(item.models)) : [];
        })
        .catch(() => [])
    );
  }
  return lensLists.get(url);
}

/**
 * Linsskyddet för modellen, i samma sort om den finns, annars det första.
 * @param {Array<{ url: string, sort: string | null, models: string[] }>} list
 * @param {ReturnType<typeof ownProduct>} own
 * @param {{ model?: string }} model
 */
function lensFor(list, own, model) {
  const fits = list.filter((item) => item.models.some((name) => clean(name) === clean(model.model)));
  return fits.find((item) => clean(item.sort) === own.colour) ?? fits[0] ?? null;
}

/**
 * Skyddet för modellen av samma sort, ur kollektionen filtrerad på modellen,
 * M-133.
 * @returns {Promise<string | null>} Skyddets adress, ur Liquid
 */
async function findProtector(own, model, signal) {
  const response = await fetch(`${protectorHref(own, model)}&section_id=${PROTECTOR_SECTION}`, { signal });
  if (!response.ok) return null;
  const html = await response.text();
  const script = new DOMParser().parseFromString(html, 'text/html').getElementById(PROTECTOR_SECTION);
  let products = [];
  try {
    products = JSON.parse(script?.textContent || '[]') || [];
  } catch {
    return null;
  }
  const match = products.find(
    (product) =>
      product?.url &&
      Array.isArray(product.models) &&
      product.models.some((name) => clean(name) === clean(model.model)) &&
      clean(product.sort) === own.colour
  );
  return match ? match.url : null;
}

/**
 * Undantaget först, sedan adressen med modellen utbytt, utan och med -2.
 * @param {ReturnType<typeof ownProduct>} own
 * @param {{ handle: string, model?: string }} model
 */
function candidates(own, model) {
  const list = [];
  if (typeof own.exceptions[model.handle] === 'string') list.push(own.exceptions[model.handle]);
  const base = own.handle.replace(/-[12]$/, '');
  const from = handleize(own.model);
  const to = handleize(model.model || '');
  const pattern = new RegExp(`(^|-)${escapeRegExp(from)}(-|$)`);
  if (from && to && pattern.test(base)) {
    const guess = base.replace(pattern, (_, before, after) => `${before}${to}${after}`);
    list.push(guess, `${guess}-2`);
  }
  return [...new Set(list)];
}

/**
 * Frågar sektionen om en kandidat och jämför de fyra fälten, eller för
 * reserven alla utom färgen.
 * @returns {Promise<string | null>} Systerns adress, ur Liquid
 */
async function check(handle, own, model, signal, anyColour = false) {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=${SECTION}`, { signal });
  if (!response.ok) return null;
  const html = await response.text();
  const script = new DOMParser().parseFromString(html, 'text/html').getElementById('nudient-model-sibling');
  let product = null;
  try {
    product = JSON.parse(script?.textContent || 'null');
  } catch {
    return null;
  }
  if (!product || !product.url || !product.magsafe_type) return null;
  const same =
    clean(product.model) === clean(model.model) &&
    clean(product.type) === own.type &&
    (anyColour || clean(product.colour) === own.colour) &&
    clean(product.magsafe) === own.magsafe;
  return same ? product.url : null;
}

/**
 * Slår upp systern för en modell. Högst en uppslagning åt gången.
 * @param {Element} row
 * @param {{ handle: string, model?: string }} model
 * @returns {Promise<string | null>}
 */
function findSibling(row, model) {
  if (siblings.has(model.handle)) return Promise.resolve(siblings.get(model.handle) ?? null);
  if (lookup?.handle === model.handle) return lookup.promise;
  lookup?.controller.abort();

  const own = ownProduct(row);
  const controller = new AbortController();
  const promise = (async () => {
    if (own.kind === 'protector') return own.protectorUrl ? findProtector(own, model, controller.signal) : null;
    for (const handle of candidates(own, model)) {
      const url = await check(handle, own, model, controller.signal);
      if (url) return url;
    }
    const fallback = own.fallbacks[model.handle];
    if (typeof fallback === 'string') return check(fallback, own, model, controller.signal, true);
    return null;
  })().then(
    (url) => {
      siblings.set(model.handle, url);
      return url;
    },
    () => null
  );
  const current = { handle: model.handle, controller, promise };
  lookup = current;
  promise.finally(() => {
    if (lookup === current) lookup = null;
  });
  return promise;
}

/** @param {string} text */
const normalize = (text) => text.toLowerCase().replace(/[\s-]+/g, '');

const FILTER_EVENT = 'nudient-model-picker:filter';

/** Filtrets data på en kollektion där väljaren filtrerar, annars null. */
const filterConfig = () => {
  const config = /** @type {any} */ (window).nudientFilter;
  return config && config.param && config.values ? config : null;
};

/** Modellens värde i adressen, eller null. */
const urlValue = () => {
  const config = filterConfig();
  if (!config) return null;
  return new URL(window.location.href).searchParams.get(config.param);
};

/** Posten vars värde i filtret är adressens, jämfört förlåtande, M-100 punkt 6. */
const urlHandle = () => {
  const config = filterConfig();
  const value = clean(urlValue());
  if (!config || !value) return null;
  const handle = Object.keys(config.values).find((key) => clean(config.values[key]) === value);
  return handle ?? null;
};

/**
 * Samma sida med modellens värde i filtret, utan page.
 * @param {{ handle: string, model?: string }} model
 */
const filterHref = (model) => {
  const config = filterConfig();
  const url = new URL(window.location.href);
  if (!config) return url.pathname + url.search;
  url.searchParams.set(config.param, config.values[model.handle] || model.model || '');
  url.searchParams.delete('page');
  return url.pathname + url.search;
};

class NudientModelPicker extends HTMLElement {
  #built = false;
  /** Fältets och listans lyssnare kopplas en gång, också när väljaren flyttas, paket E3. */
  #wired = false;

  connectedCallback() {
    this.field = this.querySelector('.nudient-model-picker__field');
    this.value = this.querySelector('.nudient-model-picker__value');
    this.note = this.querySelector('.nudient-model-picker__note');
    this.menu = this.querySelector('.nudient-model-picker__menu');
    this.input = this.querySelector('.nudient-model-picker__input');
    this.list = this.querySelector('.nudient-model-picker__list');
    this.empty = this.querySelector('.nudient-model-picker__empty');
    this.error = this.querySelector('.nudient-model-picker__error');
    this.status = this.querySelector('[aria-live]');
    if (!this.field || !this.menu || !this.input || !this.list) return;

    if (!this.#wired) {
      this.#wired = true;
      this.field.addEventListener('click', () => (this.isOpen ? this.close(true) : this.open()));
      this.input.addEventListener('input', () => this.#filter());
      this.addEventListener('keydown', this.#onKeyDown);
      this.addEventListener('focusout', this.#onFocusOut);
      this.addEventListener('mousedown', this.#onMouseDown);
      this.list.addEventListener('click', this.#onLinkClick);
    }
    if (this.dataset.mode === 'pdp') {
      window.addEventListener('pageshow', this.#onPageShow);
      this.list.addEventListener('pointerover', this.#onRowEnter);
      this.list.addEventListener('focusin', this.#onRowEnter);
      this.list.addEventListener('pointerdown', this.#onRowEnter);
      this.list.addEventListener('pointerout', this.#onRowLeave);
      this.list.addEventListener('focusout', this.#onRowLeave);
    }
    document.addEventListener('model:change', this.#render);
    document.addEventListener(FILTER_EVENT, this.#onFilterChange);
    document.addEventListener(OPEN_EVENT, this.#onOtherOpen);
    this.#loadLens();
    this.#render();
  }

  disconnectedCallback() {
    document.removeEventListener('model:change', this.#render);
    document.removeEventListener(FILTER_EVENT, this.#onFilterChange);
    document.removeEventListener(OPEN_EVENT, this.#onOtherOpen);
    document.removeEventListener('pointerdown', this.#onOutside, true);
    window.removeEventListener('pageshow', this.#onPageShow);
  }

  get isOpen() {
    return this.field?.getAttribute('aria-expanded') === 'true';
  }

  open() {
    if (!this.#isBuilt()) this.#build();
    document.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: this }));
    this.menu.hidden = false;
    this.field.setAttribute('aria-expanded', 'true');
    this.#markCurrent();
    document.addEventListener('pointerdown', this.#onOutside, true);
    if (this.#built && (hasData() || this.#airpods())) this.#focusOnOpen();
  }

  /**
   * Sökfältet på en enhet som kan hovra. På pekskärm den valda modellens rad,
   * eller listans första rad, så att tangentbordet inte fälls ut, tillägget
   * till M-084 8 oktober 2026.
   */
  #focusOnOpen() {
    if (canHover.matches) {
      this.input.focus();
      return;
    }
    const rows = [...this.list.querySelectorAll('.nudient-model-picker__option')].filter((link) => !link.parentElement?.hidden);
    const row = rows.find((link) => link.getAttribute('aria-current') === 'true') || rows[0];
    if (!row) return;
    this.#quietFocus = true;
    row.focus({ preventScroll: true });
    this.#quietFocus = false;
    const list = this.list.getBoundingClientRect();
    const box = row.getBoundingClientRect();
    this.list.scrollTop += box.top - list.top - (list.height - box.height) / 2;
  }

  /** @param {boolean} [returnFocus] */
  close(returnFocus = false) {
    if (!this.isOpen) return;
    this.menu.hidden = true;
    this.field.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', this.#onOutside, true);
    if (returnFocus) this.field.focus();
  }

  #onOtherOpen = (event) => {
    if (event.detail !== this) this.close();
  };

  #onOutside = (event) => {
    if (!(event.target instanceof Node) || this.contains(event.target)) return;
    this.close();
  };

  /**
   * Safari ger inte länkar och knappar fokus vid musklick. Ett musklick på en
   * rad flyttade därför fokus från sökfältet till ingenting, och Horizons meny
   * stängde panelen innan valet nådde raden, FEL-menyvaljaren, M-149. Därför
   * flyttas inte fokus vid vänsterklick på raderna och fältet när listan är
   * öppen. Klicket går igenom som vanligt. Sökfältet, rullningslisten och
   * tangentbordet påverkas inte.
   * @param {MouseEvent} event
   */
  #onMouseDown = (event) => {
    if (!this.isOpen || event.button !== 0) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('.nudient-model-picker__option, .nudient-model-picker__field')) return;
    event.preventDefault();
  };

  #onFocusOut = (event) => {
    if (!this.isOpen) return;
    const next = event.relatedTarget;
    if (next instanceof Node && this.contains(next)) return;
    if (next === null) return;
    this.close();
  };

  #text(name, number) {
    return (this.dataset[name] || '').replace('[number]', String(number));
  }

  /** @type {Array<{ handle: string, name: string, model: string, brand: string, url: string, current: boolean }> | null | undefined} */
  #airpodsList = undefined;

  /** AirPods-fodralens lista, M-174, eller null på andra produkter. */
  #airpods() {
    if (this.#airpodsList !== undefined) return this.#airpodsList;
    const row = this.dataset.mode === 'pdp' ? this.closest('.nudient-model-row') : null;
    let list = null;
    if (row && ownProduct(row).kind === 'airpods') {
      try {
        const parsed = JSON.parse(row.querySelector('[data-nudient-airpods]')?.textContent || '[]');
        list = Array.isArray(parsed) ? parsed.filter((item) => item?.handle && item.url) : [];
      } catch {
        list = [];
      }
    }
    this.#airpodsList = list;
    return list;
  }

  /** Linsskydden när de har hämtats, M-133 tillägget. */
  #lens = /** @type {Array<{ url: string, sort: string | null, models: string[] } > | null} */ (null);

  /** Raden för linsskydd, eller null. */
  #lensRow() {
    const row = this.dataset.mode === 'pdp' ? this.closest('.nudient-model-row') : null;
    return row && ownProduct(row).kind === 'lens' ? row : null;
  }

  /** Hämtar linsskydden och bygger om listan när de har kommit. */
  #loadLens() {
    const row = this.#lensRow();
    if (!row || this.#lens) return;
    const own = ownProduct(row);
    if (!own.protectorUrl) return;
    lensProducts(own.protectorUrl).then((list) => {
      this.#lens = list;
      if (!this.#built) return;
      this.list.replaceChildren();
      this.#built = false;
      if (this.isOpen) {
        this.#build();
        this.#markCurrent();
      }
    });
  }

  /**
   * Linsskydd: bara modellerna som har ett, och innan svaret bara den egna.
   * @param {ReturnType<typeof getModels>} models
   */
  #lensModels(models) {
    const row = this.#lensRow();
    if (!row) return models;
    const own = ownProduct(row);
    if (!this.#lens) return models.filter((model) => clean(model.model) === clean(own.model));
    return models.filter((model) => clean(model.model) === clean(own.model) || lensFor(this.#lens, own, model));
  }

  #build() {
    const airpods = this.#airpods();
    const models = airpods || this.#lensModels(getModels());
    if ((!airpods && !hasData()) || models.length === 0) {
      this.input.closest('.nudient-model-picker__search').hidden = true;
      this.list.hidden = true;
      if (this.error) this.error.hidden = false;
      this.#built = true;
      return;
    }

    const placeholder = this.#text('searchText', models.length);
    this.input.placeholder = placeholder;
    this.input.setAttribute('aria-label', placeholder);

    /** @type {Map<string, typeof models>} */
    const groups = new Map();
    for (const model of models) {
      if (model.brand === 'other') continue;
      if (!groups.has(model.brand)) groups.set(model.brand, []);
      groups.get(model.brand).push(model);
    }
    const others = models.filter((model) => model.brand === 'other');
    if (others.length) groups.set('other', others);

    const fragment = document.createDocumentFragment();
    let index = 0;
    for (const [brand, members] of groups) {
      index += 1;
      const headingId = `${this.list.id}-group-${index}`;
      const heading = document.createElement('p');
      heading.className = 'nudient-model-picker__group';
      heading.id = headingId;
      heading.textContent = brand === 'other' ? this.dataset.otherText || '' : brand;
      const list = document.createElement('ul');
      list.className = 'nudient-model-picker__options';
      list.setAttribute('aria-labelledby', headingId);
      for (const model of members) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'nudient-model-picker__option';
        link.href = airpods ? model.url : this.#filtering() ? filterHref(model) : this.#defaultHref(model);
        link.dataset.handle = model.handle;
        link.dataset.key = normalize(model.name);
        const label = document.createElement('span');
        label.className = 'nudient-model-picker__name';
        label.textContent = model.name;
        link.append(label);
        item.append(link);
        list.append(item);
      }
      const group = document.createElement('div');
      group.className = 'nudient-model-picker__section';
      group.append(heading, list);
      fragment.append(group);
    }
    this.list.append(fragment);
    this.#built = true;
    this.#applySiblings();
  }

  /** Listan är byggd bara om raderna finns i sidan, M-085. */
  #isBuilt() {
    if (!this.#built) return false;
    if (!hasData()) return true;
    if (this.list.querySelector('.nudient-model-picker__option')) return true;
    this.list.replaceChildren();
    this.#built = false;
    return false;
  }

  /**
   * Radens adress innan uppslagningen: modellens kollektion, och för
   * skärmskydd skyddens kollektion filtrerad på modellen, M-133.
   * @param {{ handle: string, model?: string, url?: string }} model
   */
  #defaultHref(model) {
    const row = this.dataset.mode === 'pdp' ? this.closest('.nudient-model-row') : null;
    if (row) {
      const own = ownProduct(row);
      if (own.kind === 'protector' && own.protectorUrl) return protectorHref(own, model);
      if (own.kind === 'lens' && this.#lens) {
        const lens = lensFor(this.#lens, own, model);
        if (lens) return lens.url;
      }
      if (own.casesUrl) return casesHref(own, model);
    }
    return model.url || this.dataset.genericUrl || '/';
  }

  /** Produktsidan, M-086: raderna väntar på uppslagningen, utom de som är klara. */
  #applySiblings() {
    if (this.dataset.mode !== 'pdp' || this.#lensRow() || this.#airpods()) return;
    const own = getModel();
    this.list.querySelectorAll('.nudient-model-picker__option').forEach((link) => {
      const handle = link.dataset.handle;
      if (!handle || handle === own) return;
      if (siblings.has(handle)) this.#setTarget(link, siblings.get(handle));
      else link.setAttribute('data-nudient-pending', '');
    });
  }

  /**
   * @param {HTMLAnchorElement} link
   * @param {string | null | undefined} url
   */
  #setTarget(link, url) {
    link.removeAttribute('data-nudient-pending');
    if (url && link.getAttribute('href') !== url) link.setAttribute('href', url);
    /* M-157: svaret är att systern saknas, och radens adress är phone-cases */
    if (url === null) link.dataset.nudientMiss = '1';
    else delete link.dataset.nudientMiss;
  }

  /** @param {HTMLAnchorElement} link */
  #lookup(link) {
    const model = findModel(link.dataset.handle);
    const row = this.closest('.nudient-model-row');
    if (!model || !row || !link.hasAttribute('data-nudient-pending')) return Promise.resolve(undefined);
    return findSibling(row, model).then((url) => {
      if (siblings.has(model.handle)) {
        this.#setTarget(link, url);
        if (url) link.dispatchEvent(new CustomEvent('nudient:prefetch', { bubbles: true }));
      }
      return url;
    });
  }

  #hoverTimer = 0;
  /** Fokus som skriptet själv lägger vid utfällningen startar ingen uppslagning. */
  #quietFocus = false;

  /**
   * Modellbytet, tillägget till M-084 8 oktober 2026: menyn stängs direkt,
   * och fältet visar den nya modellen med väntemarkören tills sidan byts.
   */
  #leave() {
    this.close();
    this.field.setAttribute('aria-busy', 'true');
  }

  /** Tillbaka med bakåtknappen: inget väntläge kvar. */
  #onPageShow = (event) => {
    if (!event.persisted) return;
    this.field.removeAttribute('aria-busy');
    this.list.querySelectorAll('[aria-busy], [data-nudient-go]').forEach((link) => {
      link.removeAttribute('aria-busy');
      link.removeAttribute('data-nudient-go');
    });
  };

  /** @param {Event} event */
  #pendingLink(event) {
    const link = event.target instanceof Element ? event.target.closest('a.nudient-model-picker__option') : null;
    return link instanceof HTMLAnchorElement && link.hasAttribute('data-nudient-pending') ? link : null;
  }

  #onRowEnter = (event) => {
    if (event.type === 'focusin' && this.#quietFocus) return;
    const link = this.#pendingLink(event);
    if (!link) return;
    clearTimeout(this.#hoverTimer);
    if (event.type === 'pointerdown' && event.pointerType !== 'mouse') {
      this.#lookup(link);
      return;
    }
    if (event.type === 'pointerdown') return;
    this.#hoverTimer = window.setTimeout(() => this.#lookup(link), HOVER_DELAY);
  };

  #onRowLeave = () => {
    clearTimeout(this.#hoverTimer);
  };

  #markCurrent() {
    const current = this.#currentHandle();
    this.list.querySelectorAll('.nudient-model-picker__option').forEach((link) => {
      if (link.dataset.handle === current) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  #currentHandle() {
    const airpods = this.#airpods();
    if (airpods) return airpods.find((item) => item.current)?.handle || null;
    if (this.#grouping()) return getStoredModel();
    if (this.#filtering()) return urlHandle();
    return getModel();
  }

  /**
   * Söksidan, M-142: utan modellfilter i adressen visar väljaren den sparade
   * modellen, som gruppen "For your [modell]" använder, och ett byte sparar
   * modellen och byter gruppen i stället för att filtrera listan.
   */
  #grouping() {
    return this.#filtering() && Boolean(filterConfig()?.group) && !urlValue();
  }

  /** Filtrerar väljaren på plats, paket E3. Aldrig på produktsidan. */
  #filtering() {
    return this.dataset.mode !== 'pdp' && Boolean(filterConfig());
  }

  /** Efter ett byte i filtret: etiketten, den valda raden och radernas adresser. */
  #onFilterChange = () => {
    this.#render();
    if (!this.#built) return;
    this.list.querySelectorAll('.nudient-model-picker__option').forEach((link) => {
      const model = findModel(link.dataset.handle);
      if (model) link.setAttribute('href', filterHref(model));
    });
  };

  #filter() {
    const query = normalize(this.input.value);
    let hits = 0;
    this.list.querySelectorAll('.nudient-model-picker__section').forEach((section) => {
      let visible = 0;
      section.querySelectorAll('.nudient-model-picker__option').forEach((link) => {
        const show = !query || (link.dataset.key || '').includes(query);
        link.parentElement.hidden = !show;
        if (show) visible += 1;
      });
      section.hidden = visible === 0;
      hits += visible;
    });
    this.list.scrollTop = 0;
    if (this.empty) this.empty.hidden = hits > 0;
    if (this.status) this.status.textContent = this.#text('resultsText', hits);
  }

  /** @returns {HTMLAnchorElement[]} */
  #visibleLinks() {
    return [...this.list.querySelectorAll('.nudient-model-picker__option')].filter(
      (link) => !link.closest('[hidden]')
    );
  }

  #onKeyDown = (event) => {
    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault();
      event.stopPropagation();
      this.close(true);
      return;
    }
    if (!this.isOpen || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp')) return;
    const links = this.#visibleLinks();
    const active = document.activeElement;
    const position = links.indexOf(/** @type {HTMLAnchorElement} */ (active));
    if (active !== this.input && position === -1) return;
    event.preventDefault();
    if (event.key === 'ArrowDown') {
      const next = active === this.input ? links[0] : links[position + 1];
      next?.focus();
    } else if (position === 0) {
      this.input.focus();
    } else if (position > 0) {
      links[position - 1].focus();
    }
  };

  #onLinkClick = (event) => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (!link || !(link instanceof HTMLAnchorElement)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    /* AirPods-fodral, M-174: länken går till sin färdiga adress, och inget
       sparas i modellminnet. Den egna modellen fäller bara in menyn. */
    if (this.#airpods()) {
      if (link.getAttribute('aria-current') === 'true') {
        event.preventDefault();
        this.close(true);
        return;
      }
      this.#leave();
      return;
    }

    const model = findModel(link.dataset.handle);
    if (!model) return;

    /* Produktsidan, D1 del g: valet sparas med källan pdp och länken får gå
       till systern, med det sömlösa bytet i assets/nudient-product.js. Den
       egna modellen fäller bara in menyn. */
    if (this.dataset.mode === 'pdp') {
      const row = this.closest('.nudient-model-row');
      const missed = () => {
        /* Raden om varför nämner skaltypen, M-157. Utan känd skaltyp går bytet
           ändå till phone-cases, men utan raden. */
        if (link.dataset.nudientMiss && row && ownProduct(row).typeLabel) rememberMiss(ownProduct(row), model);
      };
      if (link.dataset.nudientGo) {
        missed();
        this.#leave();
        return;
      }
      const own = model.handle === getModel();
      setModel(model.handle, model.name, 'pdp');
      if (own) {
        event.preventDefault();
        this.close(true);
        return;
      }
      if (!link.hasAttribute('data-nudient-pending')) {
        missed();
        this.#leave();
        return;
      }

      /* Svaret har inte kommit: vänta högst 1,5 sekunder, M-086. */
      event.preventDefault();
      clearTimeout(this.#hoverTimer);
      link.setAttribute('aria-busy', 'true');
      const timeout = new Promise((resolve) => setTimeout(() => resolve(undefined), CLICK_TIMEOUT));
      Promise.race([this.#lookup(link), timeout]).then((url) => {
        link.removeAttribute('aria-busy');
        link.removeAttribute('data-nudient-pending');
        if (url) link.setAttribute('href', url);
        else if (!row || !ownProduct(row).casesUrl) {
          if (model.url) link.setAttribute('href', model.url);
        }
        link.dataset.nudientGo = '1';
        link.click();
      });
      return;
    }

    /* Söksidan, M-142: modellen sparas, och assets/nudient-search-model.js
       byter gruppen vid model:change. Listan filtreras inte. */
    if (this.#grouping()) {
      event.preventDefault();
      this.close(true);
      setModel(model.handle, model.name, 'picker');
      return;
    }

    /* Filtret, paket E3: på plats med Horizons filter, ingen omladdning. */
    if (this.#filtering()) {
      event.preventDefault();
      this.close(true);
      const href = link.getAttribute('href') || filterHref(model);
      const section = this.closest('.shopify-section');
      const form = section?.querySelector('facets-form-component') || document.querySelector('facets-form-component');
      setModel(model.handle, model.name, 'picker');
      if (form && typeof (/** @type {any} */ (form).updateFiltersByURL) === 'function') {
        /** @type {any} */ (form).updateFiltersByURL(href);
        document.dispatchEvent(new CustomEvent(FILTER_EVENT));
      } else {
        window.location.assign(href);
      }
      return;
    }

    setModel(model.handle, model.name, 'picker');

    const pageElement = document.getElementById('nudient-model-page');
    let onModelPage = false;
    try {
      onModelPage = this.dataset.template === 'collection' && Boolean(JSON.parse(pageElement?.textContent || 'null'));
    } catch {}

    event.preventDefault();
    if (onModelPage && model.url) {
      const target = new URL(model.url, window.location.origin);
      target.search = window.location.search;
      target.searchParams.delete('filter.p.m.attribute.compatible_models');
      window.location.assign(target.toString());
      return;
    }
    this.close(true);
  };

  #render = () => {
    let name = getModelName();
    const airpods = this.#airpods();
    if (airpods) {
      name = airpods.find((item) => item.current)?.name || '';
    } else if (this.#grouping()) {
      name = findModel(getStoredModel())?.name || '';
    } else if (this.#filtering()) {
      const model = findModel(urlHandle());
      const config = filterConfig();
      const raw = urlValue();
      // Tom parameter är alla produkter, länken i tomt läge, M-146 punkt 3
      name = raw === '' ? '' : model?.name || raw || (config?.noDefault ? '' : name);
    }
    if (this.value) {
      if (name) {
        this.value.textContent = name;
        this.value.removeAttribute('data-empty');
      } else {
        this.value.textContent = this.dataset.selectText || '';
        this.value.setAttribute('data-empty', '');
      }
    }
    if (this.note) {
      const handle = this.#currentHandle();
      const model = handle ? findModel(handle) : null;
      this.note.hidden = this.#filtering() || !(model && !model.url);
    }
    if (this.#built) this.#markCurrent();
  };
}

if (!customElements.get('nudient-model-picker')) {
  customElements.define('nudient-model-picker', NudientModelPicker);
}
